import { toast } from 'react-toastify'

import api from '@/services/api'
import apiEndPoints from '@/consts/apiEndPoints'
import handleErrors from '@/services/handleErrors'

import { confirmationDialog } from '@/components/ConfirmationDialog'

export async function createDriver(data) {
  try {
    const response = await api.post(apiEndPoints.drivers.root, {
      driver: {
        wem_nome: data.wem_nome,
        wem_rg: data.wem_rg,
        wem_cpf: data.wem_cpf,
        wem_ativo: data.wem_ativo,
      },
    })

    toast.success('Motorista salvo')

    const driver = response.data

    return driver
  } catch (error) {
    handleErrors(error, 'Não foi possível salvar o motorista')
  }
}

export async function updateDriver(driverId, data) {
  try {
    const response = await api.put(
      apiEndPoints.drivers.root.concat(`/${driverId}`),
      {
        driver: {
          wem_nome: data.wem_nome,
          wem_rg: data.wem_rg,
          wem_cpf: data.wem_cpf,
          wem_ativo: data.wem_ativo,
        },
      }
    )

    toast.success('Motorista atualizado')

    const updatedDriver = response.data
    return updatedDriver
  } catch (error) {
    handleErrors(error, 'Não foi possível atualizar o motorista')
  }
}

export async function deleteDriver(driverId, driverName) {
  const confirm = await confirmationDialog.open(
    'Confirmar',
    `Deseja remover o motorista "${driverName}"?`
  )

  if (confirm) {
    try {
      await api.delete(apiEndPoints.drivers.root.concat(`/${driverId}`))

      toast.success('Motorista removido')

      return true
    } catch (error) {
      handleErrors(error, 'Não foi possível excluir o motorista')

      return false
    } finally {
      confirmationDialog.close()
    }
  }

  confirmationDialog.close()

  return false
}
